module.exports = __webpack_public_path__ + "static/media/satisfaction.ba1a150c.svg";